<template>
  <div>
    <v-app-bar app flat height="50" :color="this.$route.path === '/globe' ? '#2A2A2A' : '#1E3A8A'" style="border-bottom:1px solid #4a4a4a;">
      <v-img @click="intoLogoPage" src="../../assets/top_bar/logoAndTitleNew.png" style="width:220px;flex:none;margin-right:14px;"></v-img>
      <v-spacer></v-spacer>
      <!--搜索框-->
      <div v-if="this.$route.path === '/globe' &&  $store.state.currGlobeMainArea !== 'AI'" style="position:relative;z-index:15;">
<!--        readonly onfocus="this.removeAttribute('readonly')"-->
        <v-text-field v-model="search_keyword" @focus="searchInputFocus" @blur="searchInputBlur" @keyup.enter.native="searchInputEnter"
                      id="searchKeywordTextField" autocomplete="off" dense outlined placeholder="地点，经纬度（例如125.3 43.8）" dark hide-details color="#ffffff"
                      style="width:480px;background:#303030;border-radius:20px;">
          <template v-slot:append>
            <p style="margin-right:10px;font-size:16px;color:#ffffff;cursor:pointer;" class="iconfontFamily mt-1">&#xe630;</p>
          </template>
        </v-text-field>
        <!-- 解决记住密码后关键词输入框会自动填充用户名的问题 -->
        <input type="text" autocomplete="new-password" style="position: absolute;left: -10000px;top: -10000px;"/>

        <div @click="clearSearchKeyword" v-if="search_keyword!==''" style="position:absolute;top:12px;right:50px;width:16px;height:16px;cursor:pointer;">
          <p style="line-height:16px;font-size:16px;color:#c4c4c4;" class="iconfontFamily">&#xe632;</p>
        </div>

        <div v-show="search_resultAreaShow" style="position:absolute;top:45px;width:480px;background:#2a2a2a;border-radius:2px;padding:0 16px;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);">

          <!--历史记录-->
          <div v-show="search_resultAreaHistoryShow && search_history.length !== 0" style="margin:7px 0;">
            <div @click="clickSearchHistory(item)" v-for="(item,index) in search_history" :key="'searchHistory'+index" style="min-height:35px;font-size:14px;color:#ffffff;cursor:pointer;display:flex;">
              <p style="line-height:35px;" class="iconfontFamily mr-4">
                {{item.type === 2 ? '&#xe63a;' : '&#xe65f;'}}
              </p>
              <p style="line-height:35px;">
                {{item.type === 2 ? item.lon + " " + item.lat : item.keyWord}}
              </p>
            </div>

            <div @click="clearSearchHistory" style="text-align:center;color:#A6A6A6;font-size:14px;cursor:pointer;">
              <p style="line-height:31px;">清空历史记录</p>
            </div>

          </div>

          <!--联想结果-->
          <div v-show="search_resultAreaAssociativeShow && search_result.length !== 0" style="margin:7px 0;">
            <div @click="clickSearchResult(item)" v-for="(item,index) in search_result" :key="'searchAssociative'+index" style="min-height:35px;font-size:14px;color:#ffffff;cursor:pointer;display:flex;">
              <span style="line-height:35px;" class="iconfontFamily mr-4">{{item.name === "经纬度地点" ? "&#xe63a;" : "&#xe628;"}}</span>
              <p style="line-height:35px;">
                {{item.name === "经纬度地点" ? item.location.lng + " " + item.location.lat :item.name}}
              </p>
            </div>
          </div>



        </div>
      </div>

<!--      <v-btn v-if="this.$route.path !== '/globe'" @click="intoGlobe" height="30" dark depressed color="#1976D2">-->
<!--        <span style="font-size:16px;">影像中心</span>-->
<!--      </v-btn>-->
<!--      <v-btn v-if="this.$route.path === '/globe'" @click="intoHome" height="30" dark depressed color="#1976D2">-->
<!--        <span style="font-size:16px;">创作中心</span>-->
<!--      </v-btn>-->
<!--      <p @click="intoNotice" v-if="!$store.state.newNotice" style="margin-left:35px;font-size:24px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe603;</p>-->
<!--      <v-badge v-if="$store.state.newNotice" color="#ff0000" dot offset-x="10" offset-y="10" style="margin-left:35px;">-->
<!--        <span @click="intoNotice" style="font-size:24px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe603;</span>-->
<!--      </v-badge>-->
      <v-menu offset-y nudge-bottom="10" nudge-width="100">
        <template v-slot:activator="{ on, attrs }">
          <v-avatar v-bind="attrs" v-on="on" color="#A6A6A6" size="30" style="margin-left:35px;" class="mr-10">
            <v-img :src="$store.state.avatar" style="width:100%;height:100%;"></v-img>
          </v-avatar>
        </template>
        <div style="width:170px;background:#ffffff;border-radius:4px;text-align:center;" class="px-4 pt-5 pb-1">
          <v-avatar color="#A6A6A6" size="30">
            <v-img :src="$store.state.avatar" style="width:100%;height:100%;"></v-img>
          </v-avatar>
          <p style="font-size:13px;" class="mt-2">{{$store.state.nickName}}</p>
<!--          <div style="height:17px;display:flex;" class="mt-4">-->
<!--            <p style="line-height:17px;font-size:12px;"><span style="font-size:15px;color:#2A82E4;" class="iconfontFamily mr-2">&#xe643;</span>下载券：{{coupon}}</p>-->
<!--            <v-spacer></v-spacer>-->
<!--            &lt;!&ndash;            color:#2A82E4;cursor:pointer;&ndash;&gt;-->
<!--            <p style="line-height:21px;font-size:12px;color:#8a8a8a;">购买</p>-->
<!--          </div>-->
          <v-divider class="mt-4"></v-divider>

          <v-list dense id="topBarUserListGroup">
            <v-list-item-group>
              <v-list-item @click="intoUserCenter">
                <v-list-item-title><span class="iconfontFamily mr-2">&#xe616;</span>个人中心</v-list-item-title>
              </v-list-item>
              <v-list-item @click="quitLogin">
                <v-list-item-title><span class="iconfontFamily mr-2">&#xe60f;</span>退出登录</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>

        </div>


      </v-menu>





    </v-app-bar>

    <quit-page-dialog :dialogShow="quitPageDialogShow" :dialogText="quitPageDialogText" :quitPageNextPage="quitPageNextPage" @hideQuitPageDialog="hideQuitPageDialog"></quit-page-dialog>

  </div>

</template>

<script>
import QuitPageDialog from '/src/components/top_bar/QuitPageDialog';
export default {
  name: "top_bar",
  components: {
    QuitPageDialog
  },
  data(){
    return{
      quitPageNextPage:"",    //在创建内容页面时，离开当前页面的情况。home首页（影像中心），notice消息页面，userCenter个人中心，quitLogin退出登录，close关闭标签页，author创作中心

      quitPageDialogShow:false,
      quitPageDialogText:"",

      coupon:0,   //券数


      //搜索相关
      search_keyword:"",
      search_resultAreaShow:false,
      search_resultAreaHistoryShow:false,
      search_resultAreaAssociativeShow:false,
      clickSearchItem:false,
      search_history:[],
      search_result:[],

      searching:false,

    }
  },
  watch:{
    //搜索栏输入变化
    search_keyword(){
      if(this.search_keyword != null && this.search_keyword !== ""){
        if(!this.clickSearchItem){
          //不是点击结果导致的输入变化，需要搜索

          //判断输入是否符合经纬度格式
          if(this.search_keyword.indexOf(" ") !== -1){
            let keywordList = this.search_keyword.split(" ");

            if(keywordList[0] !== "" && keywordList[0] >= -180 && keywordList[0] <= 180 && keywordList[1] !== "" && keywordList[1] >= -90 && keywordList[1] <= 90){

              //输入的是经纬度
              this.search_result = [];
              this.search_result.push({
                name:"经纬度地点",
                location:{
                  lat: keywordList[1],
                  lng: keywordList[0]
                },
              })

              //进行地址关键字搜索
              this.$axios({
                method:"get",
                url:"/authorApi/POI/searchPoiList",
                params:{
                  keyWord:"",
                  lat:keywordList[1],
                  lon:keywordList[0]
                }
              }).then((resultData)=>{
                resultData = resultData.data;
                if(resultData.message === "ok"){
                  if(this.search_keyword != null && this.search_keyword !== ""){
                    //有经纬度的搜索结果
                    this.search_result = this.search_result.slice(0,1);
                    //插入poi的搜索结果
                    this.search_result = this.search_result.concat(resultData.result.pois.slice(0,9));

                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = false;
                    this.search_resultAreaAssociativeShow = true;
                  }
                  else{
                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = true;
                    this.search_resultAreaAssociativeShow = false;
                  }

                }
                else{
                  console.log(resultData.status + resultData.message);
                }
              }).catch((err)=>{
                console.log(err);
              });
            }
            else{

              //输入的是地址关键字
              this.$axios({
                method:"get",
                url:"/authorApi/POI/searchPoiList",
                params:{
                  keyWord:this.search_keyword,
                  lat:"",
                  lon:""
                }
              }).then((resultData)=>{
                resultData = resultData.data;
                if(resultData.message === "ok"){
                  if(this.search_keyword != null && this.search_keyword !== ""){
                    //联想搜索词
                    this.search_result = resultData.result;
                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = false;
                    this.search_resultAreaAssociativeShow = true;
                  }
                  else{
                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = true;
                    this.search_resultAreaAssociativeShow = false;
                  }

                }
                else{
                  console.log(resultData.status + resultData.message);
                }
              }).catch((err)=>{
                console.log(err);
              });


            }
          }

          else{
            //输入的是地址关键字
            this.$axios({
              method:"get",
              url:"/authorApi/POI/searchPoiList",
              params:{
                keyWord:this.search_keyword,
                lat:"",
                lon:""
              }
            }).then((resultData)=>{
              resultData = resultData.data;
              if(resultData.message === "ok"){
                if(this.search_keyword != null && this.search_keyword !== ""){
                  //联想搜索词
                  this.search_result = resultData.result;
                  this.search_resultAreaShow = true;
                  this.search_resultAreaHistoryShow = false;
                  this.search_resultAreaAssociativeShow = true;
                }
                else{
                  this.search_resultAreaShow = true;
                  this.search_resultAreaHistoryShow = true;
                  this.search_resultAreaAssociativeShow = false;
                }

              }
              else{
                console.log(resultData.status + resultData.message);
              }
            }).catch((err)=>{
              console.log(err);
            });

          }





        }
        else{
          this.clickSearchItem = false;
        }
      }
      else{
        this.getHistory();
      }

    },

    // //监听是否展示搜索结果，判断是否显示地球蒙层
    // search_resultAreaShow() {
    //   if(this.search_resultAreaShow){
    //     this.$parent.transparentMantle = true;
    //   }
    //   else{
    //     this.$parent.transparentMantle = false;
    //   }
    // },

  },
  methods:{
    //点击logo进入首页
    intoLogoPage(){
      if(this.$route.path === '/createArticle' || this.$route.path === '/createVideo'){
        //创作中心 编辑文章页面，需要使用 window.location.href 调起离开提示
        let firstPageUrl = window.location.href.split("/").slice(0,window.location.href.split("/").length-1).join("/") + "/globe"
        window.location.href = firstPageUrl
      }
      else if(this.$route.path === '/globe'){
        //影像中心页面
        window.location.reload()
      }
      else{
        //无特殊情况，跳转即可
        this.$router.push({
          path:'/globe'
        })
      }
    },



    //点击影像中心进入球首页（仅创作中心有入口）
    intoGlobe(){
      if(this.$route.path === '/createArticle' || this.$route.path === '/createVideo'){
        //创作中心 编辑文章页面
        this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
        this.quitPageDialogShow = true;
        this.quitPageNextPage = "home";
      }
      else{
        //无特殊情况，跳转即可
        this.$router.push({
          path:'/globe'
        })
      }
    },
    //进入首页(仅在球页面才有入口)
    intoHome(){
      if(this.$store.state.globeQuitShowDialog){
        // if(this.$store.state.globeOperationScene){
        //   //在录屏页面
        //   this.quitPageDialogText = "离开当前页面会失去录制页面及未保存内容，确定离开？";
        // }
        // else{
        //
        //
        // }
        this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
        this.quitPageDialogShow = true;
        this.quitPageNextPage = "author";
      }
      else{
        this.$router.push({
          path:'/home',query: {goHome:'goHome'}
        })
      }
    },
    //进入消息通知
    intoNotice(){
      if(this.$route.path === '/home'){
        let url = document.location.toString();
        let arrObj = url.split("?");
        window.location.href = arrObj[0] + "?goHome=goHome&intoNotice=1"
      }
      else if(this.$route.path === '/systemNoticePage'){
        this.$router.push({
          path:'/home',query: {goHome:'goHome',intoNotice:'1'}
        })
      }
      else if(this.$route.path === '/globe'){
        if(this.$store.state.globeQuitShowDialog){
          // if(this.$store.state.globeOperationScene){
          //   //在录屏页面
          //   this.quitPageDialogText = "离开当前页面会失去录制页面及未保存内容，确定离开？";
          // }
          // else{
          //   this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
          //
          // }
          this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
          this.quitPageDialogShow = true;
          this.quitPageNextPage = "notice";
        }
        else{
          this.$router.push({
            path:'/home',query: {goHome:'goHome',intoNotice:'1'}
          })
        }
      }
      else{
        this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
        this.quitPageDialogShow = true;
        this.quitPageNextPage = "notice";
      }

    },
    //进入个人中心
    intoUserCenter(){
      if(this.$route.path === '/globe'){
        if(this.$store.state.globeQuitShowDialog){
          this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
          this.quitPageDialogShow = true;
          this.quitPageNextPage = "userCenter";
        }
        else{
          this.$router.push({
            path:'/userCenter'
          })
        }
      }



      // if(this.$route.path === '/home'){
      //   this.$store.state.homeLeftBarSelectedIndex = 4;
      // }
      // else if(this.$route.path === '/systemNoticePage'){
      //   this.$router.push({
      //     path:'/home',query: {goHome:'goUserCenter'}
      //   })
      // }
      // else if(this.$route.path === '/globe'){
      //   if(this.$store.state.globeQuitShowDialog){
      //     // if(this.$store.state.globeOperationScene){
      //     //   //在录屏页面
      //     //   this.quitPageDialogText = "离开当前页面会失去录制页面及未保存内容，确定离开？";
      //     // }
      //     // else{
      //     //   this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
      //     //
      //     // }
      //     this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
      //     this.quitPageDialogShow = true;
      //     this.quitPageNextPage = "userCenter";
      //   }
      //   else{
      //     this.$router.push({
      //       path:'/home',query: {goHome:'goUserCenter'}
      //     })
      //   }
      // }
      // else{
      //   this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
      //   this.quitPageDialogShow = true;
      //   this.quitPageNextPage = "userCenter";
      // }
    },

    //退出登录
    quitLogin(){
      if(this.$route.path !== '/home' && this.$route.path !== '/systemNoticePage' && this.$route.path !== '/globe' && this.$route.path !== '/userCenter'){
        this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
        this.quitPageDialogShow = true;
        this.quitPageNextPage = "quitLogin";
      }
      else if(this.$route.path === '/globe'){
        if(this.$store.state.globeQuitShowDialog){
          // if(this.$store.state.globeOperationScene){
          //   //在录屏页面
          //   this.quitPageDialogText = "离开当前页面会失去录制页面及未保存内容，确定离开？";
          // }
          // else{
          //   this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
          //
          // }
          this.quitPageDialogText = "离开当前页面会失去未保存内容，确定离开？";
          this.quitPageDialogShow = true;
          this.quitPageNextPage = "quitLogin";
        }
        else{
          this.$utils.quitLogin();
        }
      }
      else{
        this.$utils.quitLogin();
      }
    },


    //获取用户基本信息
    getUserInfo(){
      this.$axios({
        method:"get",
        url:"/authorApi/personal-data/getPersonalData",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){

          this.coupon = resultData.data.coupon
          this.$store.commit('setUserid',resultData.data.userId)
          this.$store.commit('setNickName',resultData.data.nickName)
          this.$store.commit('setAvatar',resultData.data.picture)
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },
    //获取消息中心状态
    getNewNoticeStatus(){
      this.$axios({
        method:"get",
        url:"/authorApi/notice/exitNotReadNotice",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.$store.state.newNotice = resultData.data
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },


    //隐藏提示退出创作弹窗
    hideQuitPageDialog(){
      this.quitPageDialogShow = false;
    },



    //搜索
    //搜索框获得焦点
    searchInputFocus(){
      this.search_resultAreaShow = true;
      if(this.search_keyword != null && this.search_keyword !== ""){
        this.search_resultAreaAssociativeShow = true;
        this.search_resultAreaHistoryShow = false;
      }
      else{
        this.getHistory();
      }

    },

    //搜索框失去焦点
    searchInputBlur(){
      setTimeout(()=>{
        this.search_resultAreaShow = false;
      },200)
    },

    //清空搜索框
    clearSearchKeyword(){
      this.search_keyword = '';
      document.querySelector("#searchKeywordTextField").focus()
    },

    //搜索框回车，选择第一项结果
    searchInputEnter(){
      document.querySelector("#searchKeywordTextField").blur()
      this.clickSearchItem = true;
      // this.search_keyword = this.search_result[0].name;
      if(this.search_result[0].name === "经纬度地点"){
        this.search_keyword = this.search_result[0].location.lng + " " + this.search_result[0].location.lat;
        this.addHistory(this.search_result[0].name,this.search_result[0].location.lng,this.search_result[0].location.lat,2)
      }
      else{
        this.search_keyword = this.search_result[0].name;
        this.addHistory(this.search_result[0].name,this.search_result[0].location.lng,this.search_result[0].location.lat,1)
      }
      //关闭预览
      if(this.$store.state.imagePreviewShow){
        this.$store.state.imagePreviewShow = false;
      }
      this.flyToPosition(this.search_result[0].location.lng,this.search_result[0].location.lat);
    },


    //点击历史，选择点击的历史项作为结果
    clickSearchHistory(item){
      this.clickSearchItem = true;
      // this.search_keyword = item.name;

      if(item.type === 2){
        //经纬度地点
        this.search_keyword = item.lon + " " + item.lat;
        this.addHistory(item.keyWord,item.lon,item.lat,2)
      }
      else{
        this.search_keyword = item.keyWord;
        this.addHistory(item.keyWord,item.lon,item.lat,1)
      }
      //关闭预览
      if(this.$store.state.imagePreviewShow){
        this.$store.state.imagePreviewShow = false;
      }
      this.flyToPosition(item.lon,item.lat);
      this.search_resultAreaShow = false;
      this.search_resultAreaHistoryShow = false;
    },

    //点击联想词，选择点击的联想词作为结果
    clickSearchResult(item){
      this.clickSearchItem = true;
      if(item.name === "经纬度地点"){
        this.search_keyword = item.location.lng + " " + item.location.lat;
        this.addHistory(item.name,item.location.lng,item.location.lat,2)
      }
      else{
        this.search_keyword = item.name;
        this.addHistory(item.name,item.location.lng,item.location.lat,1)
      }
      //关闭预览
      if(this.$store.state.imagePreviewShow){
        this.$store.state.imagePreviewShow = false;
      }
      this.flyToPosition(item.location.lng,item.location.lat);
      this.search_resultAreaShow = false;
      this.search_resultAreaAssociativeShow = false;
    },

    //地球飞到搜索结果位置
    flyToPosition(positionLng,positionLat){
      this.$emit("topBarSearchFlyToPosition",JSON.stringify({lng:positionLng,lat:positionLat}))
    },

    //增加搜索历史
    //type：1关键词搜索 2经纬度搜索
    addHistory(positionName,lng,lat,type){

      let param = new FormData();
      param.append('keyWord', positionName);
      param.append('lon', lng);
      param.append('lat', lat);
      param.append('type', type);

      this.$axios({
        method:"post",
        url:"/authorApi/z-user-poi-search/add",
        data: param
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          //添加历史成功

        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //获取并展示历史记录
    getHistory(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-user-poi-search/getByUser",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.search_history = resultData.data.slice(0,10);
          this.search_resultAreaShow = true;
          this.search_resultAreaHistoryShow = true;
          this.search_resultAreaAssociativeShow = false;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //清空历史记录
    clearSearchHistory(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-user-poi-search/clearHistory",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          //历史记录清空
          this.search_history = [];
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },



  },
  mounted(){
    console.log("Topbar")
    this.getUserInfo();
    if(this.$route.query.intoNotice === undefined){
      this.getNewNoticeStatus();
    }
  }
}
</script>

<style>
#topBarUserListGroup .theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before{
  opacity:0
}

#topBarUserListGroup .theme--light.v-list-item:hover::before{
  opacity:0.04
}


#searchKeywordTextField{
  padding-left:10px;
  margin-right:58px;
}


</style>
